module.exports = __webpack_public_path__ + "img/logo-up-vacanta.352633d6.png";